// O editor devolve "<p></p>" quando vazio; trata como vazio também texto só com espaços/&nbsp;
export function isRichTextEmpty(html?: string): boolean {
    if (!html) return true;
    if (/<(img|iframe|video)\b/i.test(html)) return false;

    const text = html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim();

    return text.length === 0;
}

export function normalizeRichText(html?: string): string {
    return isRichTextEmpty(html) ? '' : (html as string);
}
